import { captureError } from "@lango/api/src/lib/monitoring/sentry";
import {
  setTrpcClient,
  getTrpcClient,
  trpc as nextTrpc,
} from "@lango/api/src/utils/nextClient";

const getApiBaseUrl = () => {
  return "";
};

export const getSession = () => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get("token") || "";
  const email = url.searchParams.get("email") || "";
  return {
    token,
    email,
  };
};

export const setUpTrpc = () => {
  setTrpcClient(
    getTrpcClient({
      getSession: getSession,
      url: getApiBaseUrl(),
      getToken: async () => {
        return "";
      },
      getTzOffset: () => {
        return new Date().getTimezoneOffset();
      },
      onError: async (err) => {
        await captureError(err);
      },
      version: "latest",
    })
  );
  return nextTrpc;
};
